import cabine from '../../../services/cabineApi';
import { gotErrorFromApi } from '../../../utils/api';
import store from '../../configureStore';
import {
  eraserOutstandingDebitsList,
  getOutstandingDebitsListFromApi,
  gotOutstandingDebitsListFromApi,
} from '../../duck/legado/outstandingDebitsApp';
import {
  setFareFilterOptions,
  setFinalDateFilterOptions,
  setInitialDateFilterOptions,
  setPartnerFilterOptions,
  settingFilter,
} from '../../duck/legado/outstandingDebitsApp/filter';
import { SendLoginTokenAuth } from '../tokens';

export function getOutstandingDebitsList(
  partnerId: number | string,
  fareId: number | string,
  initialDate: string,
  finalDate: string
) {
  store.dispatch(getOutstandingDebitsListFromApi());
  return (dispatch: any) => {
    cabine
      .get(
        `/v1/legado/consulta/debitos/pendentes/${partnerId}/${fareId}/${initialDate}/${finalDate}`,
        SendLoginTokenAuth()
      )
      .then((response: any) => {
        response.data.data_de_pesquisa = {
          de: initialDate,
          ate: finalDate,
        };
        dispatch(gotOutstandingDebitsListFromApi(response.data));
      })
      .catch((error: any) => {
        gotErrorFromApi(error, dispatch, eraserOutstandingDebitsList);
      });
  };
}

export function setPartnerOption(props: string) {
  return (dispatch: any) => {
    dispatch(settingFilter());
    dispatch(setPartnerFilterOptions(props));
  };
}

export function setFareOption(props: string) {
  return (dispatch: any) => {
    dispatch(settingFilter());
    dispatch(setFareFilterOptions(props));
  };
}

export function setInitialDateOption(props: string) {
  return (dispatch: any) => {
    dispatch(settingFilter());
    dispatch(setInitialDateFilterOptions(props));
  };
}

export function setFinalDateOption(props: string) {
  return (dispatch: any) => {
    dispatch(settingFilter());
    dispatch(setFinalDateFilterOptions(props));
  };
}
